export const POLICY_HISTORY_FILTER_ALL = "ALL" as const;
export const POLICY_HISTORY_FILTER_STORE = "STORE" as const;
export const POLICY_HISTORY_FILTER_PRODUCT = "PRODUCT" as const;

export const POLICY_HISTORY_FILTERS = [
  POLICY_HISTORY_FILTER_ALL,
  POLICY_HISTORY_FILTER_STORE,
  POLICY_HISTORY_FILTER_PRODUCT,
] as const;

export type PolicyHistoryFilter = (typeof POLICY_HISTORY_FILTERS)[number];
